/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
	Container,
	Row,
	Col,
	FormGroup,
	Label,
	Card,
	CardBody,
} from 'reactstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
	CloseOutlined,
	CloudDownloadOutlined,
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
import InputAutoSelect from '~/components/InputAutoSelect';
import { LoaderLista, LoaderMini } from '~/components/Loaders';
import { dataFinalAnteriorInicial } from '~/helpers/date';
import { TransactionsContext } from '~/context/TransactionsContext';
import {
	TransacoesGrupo,
	CardGrupo,
} from '~/components/TransacoesData/TransacoesGrupo';
import { ExtratoContext } from '~/context/ExtratoContext';
import {
	TransacoesSimples,
	CardSimples,
} from '~/components/TransacoesData/TransacoesSimples';

import ReactGA from 'react-ga4';
import { FilterAndDown, TextClick, ButtonStyled } from './styles';





export default function Transacoes(props) {
	const { user, isMobile } = props;

	const {
		loaderDownload,
		setLoaderDownload,
		getTransacoes,
		getTransacoes7Dias,
		getTransacoesDataPickerEnd,
		authGroup,
		authToken,
		transacoesDataPickerEnd,
		transacoesGrupo,
		transacoes7Dias,
		transacoes,
		setLoadingTransactions,
		loadingTransactions,
		totalGrupos,
		getExport,
		gruposTitularConcatenado
	} = useContext(TransactionsContext);

	const {
		revendaHierarquiaList,
		getHierarquiaByDoc
	} = useContext(ExtratoContext);

	const [transacoesPeriodo, setTransacoesPeriodo] = useState({
		dados: transacoes.hoje.dados,
		loading: false,
		error: null,
	});

	const [gruposPage, setGruposPage] = useState([]);

	const [dataRange, setDataRange] = useState({
		dateInit: '',
		dateEnd: '',
	});

	const [params, setParams] = useState({
		dateInit: moment().format('YYYY-MM-DD'),
		dateEnd: moment().format('YYYY-MM-DD'),
	});

	const [button, setButton] = useState({
		hoje: true,
		dias7: false,
	});

	const [limparFiltro, setLimparFiltro] = useState(false);

	const [filter, setFilter] = useState('todos');

	const [pagina, setPagina] = useState(1);


	const [paginaGrupo, setPaginaGrupo] = useState(1);

	const [titularVisible, showTitular] = useState(false);

	const [idTitular, setIdTitular] = useState(
		['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0
			? 'todos'
			: user.dados.lojista_id
	);

	// eslint-disable-next-line consistent-return
	const tableVendas = (tipoCliente) => {
		switch (tipoCliente) {
			case 'simples':
				return (
					<TransacoesSimples
						transacoes={transacoesPeriodo}
						loadingTransacoes={loadingTransactions}
					/>
				);
			case 'split':
				return (
					<TransacoesGrupo
						transacoes={gruposPage}
						loadingTransacoes={loadingTransactions}
					/>
				);
			case 'grupo':
				return (
					<TransacoesGrupo
						transacoes={gruposPage}
						loadingTransacoes={loadingTransactions}
					/>
				);
			default:
				break;
		}
	};

	function handlerPagination(page) {
		setPagina(page);
		setPaginaGrupo(page);
		if(transacoesGrupo.listaConcatenadaGrupo[0]){
			setGruposPage(
				transacoesGrupo.listaConcatenadaGrupo[0]
			);
		}
		switch (filter) {
			case 'hoje':
				if (gruposPage && gruposPage.length > 0) {
					setGruposPage(
						transacoesGrupo.listaConcatenadaGrupo[0]
					);
				} else {
					authToken().then((res) =>
						getTransacoes(
							page,
							res.data.id_token,
							user.dados.user_id
						)
					);
				}
				break;
			case 'todos':
				if (gruposPage && gruposPage.length > 0) {
					setGruposPage(
						transacoesGrupo.listaConcatenadaGrupo[0]
					);
				} else {
					authToken().then((res) =>
						getTransacoes(
							page,
							res.data.id_token,
							user.dados.user_id
						)
					);
				}
				break;
			case 'sete_dias':
				if (gruposPage && gruposPage.length > 0) {
					setGruposPage(
						transacoesGrupo.listaConcatenadaGrupo[0]
					);
				} else {
					authToken().then((res) =>
						getTransacoes7Dias(page, res.data.id_token)
					);
				}
				break;
			case 'data_picker':
				if (gruposPage && gruposPage.length > 0) {
					setGruposPage(
						transacoesGrupo.listaConcatenadaGrupo[0]
					);
				} else {
					authToken().then((res) =>
						getTransacoesDataPickerEnd(
							page,
							dataRange.dateEnd,
							dataRange,
							res.data.id_token
						)
					);
				}
				break;
			case '':
				if (gruposPage && gruposPage.length > 0) {
					setGruposPage(
						transacoesGrupo.listaConcatenadaGrupo[0]
					);
				} else {
					authToken().then((res) =>
						getTransacoes(
							page,
							res.data.id_token,
							user.dados.user_id
						)
					);
				}
				break;
			default:
				// eslint-disable-next-line no-console
				console.log(`Sorry, we are out of ${filter}.`);
		}
	}

	function showFieldGroups() {
		showTitular(true);
	}

	function handleClickDownloadVendasGA4() {
		ReactGA.event({
			category: "download_vendas_click",
			action: "Download Vendas",
			label: "Baixando planilha de vendas",
		});
	}


	function handleFiltroHojeGA4() {
		ReactGA.event({
			category: "filtro_hoje_Vendas_click",
			action: "Filtro Hoje Vendas",
			label: "Filtrando Hoje Vendas",
		});
	}

	function handleFiltro7DiasGA4() {
		ReactGA.event({
			category: "filtro_7dias_Vendas_click",
			action: "Filtro 7 dias Vendas",
			label: "Filtrando 7 dias Vendas",
		});
	}

	function handleFiltroDataGA4() {
		ReactGA.event({
			category: "filtro_data_Vendas_click",
			action: "Filtro por data Vendas",
			label: "Filtrando por data Vendas",
		});
	}

	function handleFiltroTitularGA4() {
		ReactGA.event({
			category: "filtro_titular_Vendas_click",
			action: "Filtro por titular Vendas",
			label: "Filtrando por titular Vendas",
		});
	}

	useEffect(() => {
		const cargoUser = user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.cargo.toLowerCase() !== 'distribuidor - filial' ? 'participante' : 'revenda';

		if(cargoUser === 'participante' && revendaHierarquiaList.length === 0){
			getHierarquiaByDoc(user.dados.documento)
		}
	}, []);
	/**
	 * Efeitos para que os dados atualizem
	 */

	useEffect(() => {
		setLoadingTransactions(true);
		authGroup(
			params,
			pagina,
			filter,
			['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0
				? idTitular
				: user.dados.lojista_id,
			showFieldGroups
		);
	}, [idTitular, params]);

	useEffect(() => {
		setTransacoesPeriodo({
			dados: transacoes.hoje.dados,
			loading: false,
			error: null,
		});
	}, [transacoes, limparFiltro]);

	useEffect(() => {
		if (button.dias7 === true) {
			setTransacoesPeriodo({
				dados: transacoes7Dias.lista,
				loading: false,
				error: null,
			});
		} else if (dataRange.dateEnd !== '') {
			setTransacoesPeriodo({
				dados: transacoesDataPickerEnd.lista,
				loading: false,
				error: null,
			});
		}
	}, [
		button.dias7,
		dataRange.dateEnd,
		transacoes7Dias,
		transacoesDataPickerEnd,
	]);

	useEffect(() => {
		setGruposPage(transacoesGrupo.listaConcatenadaGrupo[0]);
	}, [transacoesGrupo]);

	useEffect(() => {
		if (dataRange.dateEnd !== '') {
			if (dataFinalAnteriorInicial(dataRange.dateInit, dataRange.dateEnd)) {
				toast.warning('Data final não pode ser anterior a data inicial');
				setDataRange({
					dateInit: '',
					dateEnd: '',
				});
			} else {
				updateDateFilter();
				handleFiltroDataGA4();
			}
		}
	}, [dataRange]);
	/**
	 *
	 */

	useEffect(() => {
		authGroup(
			params,
			pagina,
			filter,
			['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0
				? idTitular
				: user.dados.lojista_id,
			showFieldGroups
		);
	}, [pagina]);

	useEffect(() => {
		authGroup(
			params,
			paginaGrupo,
			filter,
			['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0
				? idTitular
				: user.dados.lojista_id,
			showFieldGroups
		);
	}, [paginaGrupo]);
	/**
	 * Filtros
	 */

	function updateDateFilter() {
		setFilter('data_picker');
		setLoadingTransactions(true);

		const paramsTemp = {
			dateInit: moment(dataRange.dateInit).format('YYYY-MM-DD'),
			dateEnd: moment(dataRange.dateEnd).format('YYYY-MM-DD'),
		};
		// eslint-disable-next-line prettier/prettier
		authGroup(paramsTemp, pagina, 'data_picker_end', idTitular, showFieldGroups);

		setTransacoesPeriodo({
			dados: transacoesDataPickerEnd.lista,
			loading: false,
			error: null,
		});

		setButton({
			hoje: false,
			dias7: false,
		});

		setParams({
			dateInit: moment(dataRange.dateInit).format('YYYY-MM-DD'),
			dateEnd: moment(dataRange.dateEnd).format('YYYY-MM-DD'),
		});

		setPagina(1);
		setPaginaGrupo(1);
	}

	function handlerFiltrar7Dias() {
		setFilter('sete_dias');
		setLoadingTransactions(true);

		const paramsTemp = {
			dateInit: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		};

		authGroup(paramsTemp, pagina, 'sete_dias', idTitular, showFieldGroups);

		setTransacoesPeriodo({
			dados: transacoes7Dias.lista,
			loading: false,
			error: null,
		});

		setButton({
			hoje: false,
			dias7: true,
		});

		setParams({
			dateInit: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setPagina(1);
		setPaginaGrupo(1);
		handleFiltro7DiasGA4();
	}

	function handlerFiltrarHoje() {
		setFilter('todos');
		setLoadingTransactions(true);

		const paramsTemp = {
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		};

		authGroup(paramsTemp, pagina, 'todos', idTitular, showFieldGroups);
		setTransacoesPeriodo({
			dados: transacoes.hoje.dados,
			loading: false,
			error: null,
		});

		setButton({
			hoje: true,
			dias7: false,
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setPagina(1);
		setPaginaGrupo(1);
		handleFiltroHojeGA4();
	}

	function handlerLimparFiltro() {
		setFilter('');

		setTransacoesPeriodo({
			dados: transacoes.hoje.dados,
			loading: false,
			error: null,
		});

		setButton({
			hoje: true,
			dias7: false,
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setIdTitular(
			['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0
				? 'todos'
				: user.dados.lojista_id
		);

		setLimparFiltro(true);
		setPagina(1);
		setPaginaGrupo(1);
	}


	const options = useMemo(() =>[{"documento": "","nome": "Todos"}, ...revendaHierarquiaList], [revendaHierarquiaList]);
	const selectedValue = options.find(opt => opt?.documento === idTitular) || null;

	const optionsGrupo = useMemo(() =>[{id: 'todos', grupo: {"documento": "","nome": "Todos"}}, ...gruposTitularConcatenado], [gruposTitularConcatenado]);
	const selectedValueGrupo = optionsGrupo.find(opt => opt?.id === idTitular) || null;


	const ColData = (
		<>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data inicial"
						dateFormat="dd/MM/yyyy"
						className="form-control notranslate"
						selected={dataRange.dateInit}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateInit: value,
							})
						}
					/>
				</FormGroup>
			</Col>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data final"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block w-100 notranslate"
						selected={dataRange.dateEnd}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateEnd: value,
							})
						}
					/>
				</FormGroup>
			</Col>
		</>
	)

	return (
		<Container fluid>
			<Card
				style={{
					boxShadow: 'unset',
					borderRadius: '0px 18px 18px 18px',
				}}>
				<CardBody>
					<Row>
						<Col md="4" sm="12">
							<FormGroup>
								<Label className="d-block">
									Filtrar por período
								</Label>
								<Row>
									<Col>
										<ButtonStyled
											className="w-100 my-0"
											disabled={button.hoje}
											onClick={() => {
												setGruposPage([])
												handlerFiltrarHoje()
											}}>
											Hoje
										</ButtonStyled>
									</Col>
									<Col>
										<ButtonStyled
											className="w-100 my-0"
											disabled={button.dias7}
											onClick={() => {
												setGruposPage([])
												handlerFiltrar7Dias()
											}}>
											7 dias
										</ButtonStyled>
									</Col>
								</Row>
							</FormGroup>
						</Col>
						<Col md={titularVisible ? '4' : '8'} sm="12">
							<FormGroup>
								<Label className="d-block notranslate">
									Filtrar por data
								</Label>
								{!isMobile ?
									<Row>
										{ColData}
									</Row>
									: <>{ColData}</>
								}
							</FormGroup>
						</Col>
						{(titularVisible && 
							revendaHierarquiaList.length > 0) ? (
							<Col md="4" sm="12">
								<FormGroup>
									<Label className="d-block">
										Filtrar por Titular
									</Label>
									<Row>
										<Col>
											<FormGroup className="d-flex flex-column">
												{revendaHierarquiaList && revendaHierarquiaList.length &&
													<InputAutoSelect
														options={options}
														getOptionLabel={(option) => `${option?.documento   || ''}${option?.documento ? ' - ' : ''}${option?.nome   || ''}` || ''}
														isOptionEqualToValue={(optionSelect, valueSelect) => optionSelect.documento === valueSelect}
														value={selectedValue}
														onChangeOption={(evt, select) => {
															if (select?.documento) {
																setIdTitular(
																	select.documento
																);
															}else{
																setIdTitular("")
															}
															handleFiltroTitularGA4();
														}}
													/>
												}
											</FormGroup>
										</Col>
									</Row>
								</FormGroup>
							</Col>
						) : 
							gruposTitularConcatenado && gruposTitularConcatenado.length && (
							<Col md="4" sm="12">
								<FormGroup>
									<Label className="d-block">
										Filtrar por Titular
									</Label>
									<Row>
										<Col>
											<FormGroup className="d-flex flex-column">
												{gruposTitularConcatenado && gruposTitularConcatenado.length &&
													<InputAutoSelect
														options={optionsGrupo}
														getOptionLabel={(option) => `${option?.grupo?.documento    || ''}${option?.grupo?.documento  ? ' - ' : ''}${option?.grupo?.nome   || ''}` || ''}
														isOptionEqualToValue={(optionSelect, valueSelect) => optionSelect?.id  === valueSelect}
														value={selectedValueGrupo}
														onChangeOption={(evt, select) => {
															if (select?.id ) {
																setIdTitular(
																	select?.id 
																);
															}
															handleFiltroTitularGA4();
														}}
													/>
												}
											</FormGroup>
										</Col>
									</Row>
								</FormGroup>
							</Col>
						)}
					</Row>
				</CardBody>
			</Card>
			{user.dados.tipo_cliente === 'simples' && transacoesPeriodo && (
				<CardSimples
					transacoes={transacoesPeriodo}
					loadingTransactions={loadingTransactions}
				/>
			)}

			{['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0 && (
				<CardGrupo
					transacoes={transacoesPeriodo}
					gruposPage={gruposPage}
					totalGrupos={totalGrupos}
					loadingTransactions={loadingTransactions}
				/>
			)}

			<Row className="mt-5">
				<Col>
					<LoaderLista
						loading={loadingTransactions}
						lista={
							gruposPage &&
								['grupo', 'split'].indexOf(
									user.dados.tipo_cliente
								) >= 0
								? gruposPage
								: transacoesPeriodo.dados.data !== undefined
									? transacoesPeriodo.dados.data
									: []
						}
						error={transacoesPeriodo.error}>
						<FilterAndDown>
							{/* {user.dados.tipo_projeto.toLowerCase() === 'intelbras' &&
								<> */}
							{
								['grupo', 'split'].indexOf(
									user.dados.tipo_cliente
								) >= 0 ? (
									!loaderDownload ? (
										<TextClick
											tabIndex="0"
											role="button"
											onClick={() => {
												setLoaderDownload(true);
												authToken().then((res) => {
													getExport(
														idTitular,
														res.data.id_token,
														params
													);
													handleClickDownloadVendasGA4();
												});
											}}>
											<CloudDownloadOutlined className="mr-1" />
											Fazer Download
										</TextClick>
									) : (
										<LoaderMini />
									)
								) : !loaderDownload ? (
									<TextClick
										tabIndex="0"
										role="button"
										onClick={() => {
											setLoaderDownload(true);
											authToken().then((res) => {
												getExport(
													user.dados.user_id,
													res.data.id_token,
													params
												);
											});
											handleClickDownloadVendasGA4();
										}}>
										<CloudDownloadOutlined className="mr-1" />
										Fazer Download
									</TextClick>
								) : (
									<LoaderMini />
								)
							}
							{/* </>
							} */}
							<TextClick
								tabIndex="0"
								role="button"
								onKeyPress={() => handlerLimparFiltro()}
								onClick={() => handlerLimparFiltro()}>
								<CloseOutlined className="mr-1" />
								Limpar filtros
							</TextClick>
						</FilterAndDown>

						{/** Componente Tabela */}
						<div className="table-responsive">
							{tableVendas(user.dados.tipo_cliente)}
						</div>

						<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
							{['grupo', 'split'].indexOf(
								user.dados.tipo_cliente
							) >= 0 ? (
								<Pagination
									activePage={paginaGrupo}
									totalItemsCount={
										totalGrupos.total_paginas
									}
									onChange={(page) => handlerPagination(page)}
									itemsCountPerPage={1}
									prevPageText={<ChevronLeftOutlined />}
									nextPageText={<ChevronRightOutlined />}
									firstPageText={<FirstPageOutlined />}
									lastPageText={<LastPageOutlined />}
								/>
							) : (
								<Pagination
									activePage={pagina}
									totalItemsCount={
										totalGrupos.total_paginas
									}
									onChange={(page) => handlerPagination(page)}
									prevPageText={<ChevronLeftOutlined />}
									nextPageText={<ChevronRightOutlined />}
									firstPageText={<FirstPageOutlined />}
									lastPageText={<LastPageOutlined />}
								/>
							)}
						</div>
					</LoaderLista>
				</Col>
			</Row>
		</Container>
	);
}
